import Requisicao from "./RequisicaoService";

class ClienteModalidadePagamentoService {                
    static async listar() {        
        return Requisicao.get('cliente-modalidade-pagamento');
    }   

    static async gravar(dados) {        
        return Requisicao.post('cliente-modalidade-pagamento', dados);
    } 
}

export default ClienteModalidadePagamentoService;